import React, { ChangeEvent } from 'react';
import { Col } from 'antd';
import { FormikContextType } from 'formik';

import FormError from 'components/molecules/form-error';
import Input from 'components/organisms/input';
import { SendCommunicationSecondStepForm } from 'types';
import CardSendCommunication from 'components/molecules/card-send-communication';
import { useIntl } from 'common/config/i18n';

export type Props = {
  formik: FormikContextType<SendCommunicationSecondStepForm>;
  signatureValue: string;
  handleSignatureChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

const TargetSignature = ({ formik, signatureValue, handleSignatureChange }: Props) => {
  const { t } = useIntl();

  return (
    <CardSendCommunication title={t('sendCommunication', 'signatureTitle')} style={{ marginTop: '1rem' }}>
      <Col>
        <Input name="signature" value={signatureValue} onChange={handleSignatureChange} width="300px" maxLength={50} />
        <FormError formik={formik} fieldName="signature" />
      </Col>
    </CardSendCommunication>
  );
};

export default TargetSignature;
